"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountIsland = void 0;
var react_1 = __importDefault(require("react"));
var ThemeProvider_1 = __importDefault(require("@mui/material/styles/ThemeProvider"));
var MsiaTheme_1 = __importDefault(require("./MsiaTheme"));
var renderRoot_1 = require("./renderRoot");
/**
 * Mount a React island into the given DOM element and wrap its content with the
 * shared MSIA MUI ThemeProvider. Use this for every standard island root unless
 * the rendered tree manages its own ThemeProvider — currently only the three
 * "Wrapped*" delegating sidebars (Livestream/Seminar-Leader/Initiate) and
 * Donations/Donate.tsx fall into that category.
 *
 * Internally delegates to {@link renderInto} so the same per-element React-root
 * caching applies; calling `mountIsland` repeatedly on the same DOM node is
 * safe and re-renders rather than re-mounts.
 */
function mountIsland(el, children) {
    (0, renderRoot_1.renderInto)(el, react_1.default.createElement(ThemeProvider_1.default, { theme: MsiaTheme_1.default }, children));
}
exports.mountIsland = mountIsland;
